import { FC, ReactNode } from "react";
import classnames from "classnames";

import styles from "./FormBlock.module.scss";
import ICheckbox from "../ICheckbox";
import { Controller } from "react-hook-form";
import { useHandleForm } from "../../hooks/useHandleForm";

export interface IFormBlockProps {
  name?: string | JSX.Element;
  children?: ReactNode;
  type?: "easy" | "bordered";
  controlName?: string;
  className?: string;
  controlField?: any;
  disabled?: boolean;
  write?: any;
}

export const FormBlock: FC<IFormBlockProps> = ({
  type = "bordered",
  name,
  children,
  disabled,
  controlName,
  write,
  className,
  controlField,
}) => {
  // const { control, watchAllField } = useHandleForm(null, null, null);

  return (
    <>
      {controlName ? (
        <div className={styles.controlWrap}>
          <Controller
            control={controlField}
            name={controlName}
            render={({ field: { value, onChange } }) => (
              <>
                <ICheckbox
                  checked={value}
                  onChange={onChange}
                  label={name}
                  className={classnames(styles.checkBoxTitle, {
                    [styles.checked]: value,
                  })}
                  disabled={disabled}
                />
                {value && (
                  <div
                    className={classnames(styles.FormBlock, {
                      [styles.FormBlockTypeEasy]: type === "easy",
                      [styles.disabled]: disabled,
                    })}
                    tabIndex={disabled ? -1 : 0}
                  >
                    {children}
                  </div>
                )}
              </>
            )}
          />
        </div>
      ) : (
        <div
          className={classnames(styles.FormBlock, className, {
            [styles.FormBlockTypeEasy]: type === "easy",
            [styles.disabled]: disabled,
            [styles.write]: write,
          })}
        >
          {name && (
            <div className={styles.FormBlockName}>
              <span>{name}</span>
            </div>
          )}
          {children}
        </div>
      )}
    </>
  );
};
